import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";
import swal from "sweetalert";
import { API_URL } from "../constant";
import Loader from "./loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $, { param, readyException } from 'jquery';


function ItemList() {

  const navigat = useNavigate();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  $('#example').DataTable().destroy();

  $(document).ready(function () {

    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort'],

      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
      responsive: true
    });
  });


  /*********************get parameter from url*********************************** */
  const params = useParams();

  /******************************************************** */

  useEffect(() => {
    document.title = "Item list";
    getItemData();
  }, [1]
  );
  /************Get all state data********************** */
  let getItemData = async (type = "") => {
    // const datas = {'pid':params.pid} ;
    //  console.log(datas);
    let formData = {
      'type': type
    };

    const res = await axios.post(API_URL + 'admin/item_list', formData)
      .then(ress => {
        //      console.log(ress.data);
        setUserData(ress.data.Rdata);
        setIsLoading(false);
      });
    //  console.log(res.data);
  }

  /******************Delete user****************************** */
  let deleteData = async (vals) => {
    const dataDel = { "id": vals };
    const res = await axios.post(API_URL + 'admin/deleteItemData', dataDel)
      .then(ress => {
        if (ress.status == '200') {
          swal("Item Deleted");
        } else {
          swal("Some error occured, please try after some time. ");
        }
        getItemData();

      });

  }

  /******************Redirecting to edit page***************************** */
  let editUser = (data) => {
    console.warn("id=" + data);
    return navigat('/edit_item/' + data);
  }

  const handleFilter = (event) => {
    getItemData(event.target.value);
  }


  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
          {isLoading ? (<Loader />) : (
            <>
              <div className="content-wrapper">
                <div className="row">

                  <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">All Items </h4>


                        <div className="table-responsive pt-3">
                          {/* <table className="table table-bordered display responsive nowrap" id="example"> */}
                          <select onChange={handleFilter} className="search-option">
                            <option value="">All</option>
                            <option value="Consumable">Consumable</option>
                            <option value="Non consumable">Non Consumable</option>
                          </select>
                          <table className="table table-bordered display  nowrap" id="example">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Action</th>
                                <th>Type</th>
                                <th>Item</th>
                                <th>Make / Model</th>
                                <th>Added On</th>
                                <th>Description</th>

                              </tr>
                            </thead>
                            <tbody>

                              {userData.map((udata, index) => (
                                <tr key={index}>
                                  <td></td>
                                  <td>  <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Edit Item" onClick={() => { editUser(udata.id) }}>
                                    <i className="typcn typcn-edit  text-primary"></i>
                                  </button>

                                    <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Delete Item" onClick={() => { if (window.confirm('Delete the item?')) { deleteData(udata.id) } }}>
                                      <i className="typcn typcn-trash text-success"></i>
                                    </button>
                                  </td>
                                  <td> {udata.type}</td>
                                  <td> {udata.item_name}</td>
                                  <td> {udata.make_model}</td>
                                  <td> <Moment format="DD-MM-YYYY">{udata.date}</Moment> </td>
                                  <td> <div className="col-md-4">{udata.description}</div></td>

                                </tr>
                              )
                              )}

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <Footer />
            </>
          )}
        </div>

      </div>

    </div>);
}

export default ItemList;